import { AppContainer } from 'react-hot-loader'
import { Provider, ReactReduxContext } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import './i18n'
import App from './App'
import configureStore, { history } from './redux/store'

const store = configureStore()
const render = () => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store} context={ReactReduxContext}>
                <App history={history} context={ReactReduxContext} />
            </Provider>
        </AppContainer>,
        document.getElementById('root')
    )
}

render()

// Hot reloading
if (module.hot) {
    // Reload components
    module.hot.accept('./App', () => {
        render()
    })
}
